import type { getAboutUsPageContent_aboutUsModel_content } from '~/types/generated/cms/getAboutUsPageContent';
import type { getLongReadOrProductBySlug_allProductPages_content } from '~/types/generated/cms/getLongReadOrProductBySlug';
import { BlockRenderer } from './BlockRenderer';
import DatoMetaTags from './DatoMetaTags';
import type { BlockRendererOverrides } from './BlockRenderer';
import type { DatoMetaTagProps } from './DatoMetaTags';
import type { ReactNode } from 'react';

interface Props {
  content:
    | readonly getLongReadOrProductBySlug_allProductPages_content[]
    | readonly getAboutUsPageContent_aboutUsModel_content[];
  children: ReactNode;
  metaTags: DatoMetaTagProps;
  blockRendererOverrides?: BlockRendererOverrides;
}

/** This is a parent component to be reused on all dato pages that follow the same set up as our Product page.
 * It takes the page's content and renders it with the BlockRenderer component.
 * It takes the Seo tags and renders them with the DatoMetaTags component.
 * Anything fed into the children prop will be rendered above the blocks that are created in Dato.
 */
const DatoPage: React.FC<Props> = ({ content, children, metaTags, blockRendererOverrides }) => {
  console.log(content);
  return (
    <>
      <DatoMetaTags {...metaTags} />
      {children}
      {content.map((block: any) => (
        <BlockRenderer key={block.id} block={block as any} overrides={blockRendererOverrides} />
      ))}
    </>
  );
};

export default DatoPage;
